module.exports = __webpack_public_path__ + "img/UV.7df1ec28.png";